import React, { Component } from 'react';
import { api_url, headers } from '../../../common/config';
import placeholder from '../../../assets/images/logo/icon-h.svg';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
class ActivitiesCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            image: placeholder,
        };
    }

    componentDidMount() {
        this.getImage();
    }

    getImage = () => {
        if (this.props.image !== undefined) {
            fetch(`${api_url}/autism/files/${this.props.image}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        image: res.data.data.full_url,
                    });
                });
        }
    };

    render() {
        const { t } = this.props;
        return (
            <>
                {i18next.language === 'ar' ? (
                    <div className='activity-card'>
                        <div className='lecture-container'>
                            <div className='m-3 w-100'>
                                <div className='lecture-type'>
                                    <div className='lecture-oval'>
                                        <h6>{this.props.ar_type}</h6>
                                    </div>
                                </div>
                                <div className='lecture-title'>
                                    <h1>{this.props.ar_title}</h1>
                                </div>
                                <hr />
                                <div className='speaker-container'>
                                    {this.props.ar_desc === '' ||
                                    this.props.ar_desc === null ? (
                                        <>
                                            <div className='speaker-img'>
                                                <img
                                                    src={this.state.image}
                                                    alt='speaker'
                                                />
                                            </div>
                                            <div className='speaker-details'>
                                                <h6>{this.props.ar_name}</h6>
                                                <h6 className='job'>
                                                    {this.props.ar_job}
                                                </h6>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className='speaker-img'>
                                                <img
                                                    src={this.state.image}
                                                    alt='speaker'
                                                />
                                            </div>
                                            <div className='speaker-details'>
                                                <h6 className='job'>
                                                    {this.props.ar_desc}
                                                </h6>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='date-container'>
                                <div className='date-details'>
                                    <div className='circle date-circle'></div>
                                    <h6>{this.props.ar_date}</h6>
                                    <div className='circle time-circle'></div>
                                    <h6>{this.props.ar_time}</h6>
                                </div>
                                <div className='btn-container'>
                                    <a
                                        href={this.props.url}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        <button className='register-btn'>
                                            {t('registerBtn')}
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='activity-card'>
                        <div className='lecture-container'>
                            <div className='m-3 w-100'>
                                {this.props.en_type.length !== 0 ? (
                                    <div className='lecture-type'>
                                        <div className='lecture-oval'>
                                            <h6>{this.props.en_type}</h6>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='lecture-type'>
                                        {/* <div
                                            className='lecture-oval'
                                            style={{
                                                backgroundColor: 'transparent',
                                            }}
                                        ></div> */}
                                    </div>
                                )}

                                <div className='lecture-title'>
                                    <h1>{this.props.en_title}</h1>
                                </div>
                                <hr />
                                <div className='speaker-container'>
                                    {this.props.en_desc === '' ||
                                    this.props.en_desc === null ? (
                                        <>
                                            <div className='speaker-img ml-0 mr-2'>
                                                <img
                                                    src={this.state.image}
                                                    alt='speaker'
                                                />
                                            </div>
                                            <div className='speaker-details text-left'>
                                                <h6>{this.props.en_name}</h6>
                                                <h6 className='job'>
                                                    {this.props.en_job}
                                                </h6>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className='speaker-img ml-0 mr-2'>
                                                <img
                                                    src={this.state.image}
                                                    alt='speaker'
                                                />
                                            </div>
                                            <div className='speaker-details text-left'>
                                                <h6 className='job'>
                                                    {this.props.en_desc}
                                                </h6>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='date-container'>
                                <div className='date-details text-left'>
                                    <div className='circle date-circle '></div>
                                    <h6 className='ml-0 mr-4'>
                                        {this.props.en_date}
                                    </h6>
                                    <div className='circle time-circle'></div>
                                    <h6 className='ml-0 mr-4'>
                                        {this.props.en_time}
                                    </h6>
                                </div>
                                <div className='btn-container'>
                                    <a
                                        href={this.props.url}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        <button className='register-btn'>
                                            {t('registerBtn')}
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(ActivitiesCard);
